import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import {ActivatedRoute} from '@angular/router';
import {NgbModal, ModalDismissReasons} from '@ng-bootstrap/ng-bootstrap';
import { QuickLookComponent } from './quick-look/quick-look.component';
import { ProductService } from 'src/app/shared/services/product.service';
import { Router } from "@angular/router";

@Component({
  selector: 'app-products',
  templateUrl: './products.component.html',
  styleUrls: ['./products.component.scss'],
  encapsulation: ViewEncapsulation.None,
})
export class ProductsComponent implements OnInit {
  collection:{category: string};
  products = [];
  filteredProducts = [];
  brand:string;
  power:string;
  sort:string;
  closeResult: string;
  categorySlug:string;
  brands;
  powers;
  loader:boolean = false;

  constructor(
    private route: ActivatedRoute,
    private modalService: NgbModal,
    private productService:ProductService,
  private router:Router) {
    this.categorySlug = this.route.snapshot.params['category'];
    this.loader = true;
    this.productService.getProducts().subscribe(res =>{
       this.products = res;
       route.queryParams.subscribe(params => {
         /* if( params['brand'] === this.brand ){
          console.log('repeated');
         }else{
          console.log('not repeated');
         } */
        this.brand = params['brand'];
        this.power = params['power'];
        this.sort = params['sort_by'];
        if( this.brand ){
          this.filteredProducts = this.products.filter( p => (p.payload.doc.data().brand === this.brand) );
        }else if( this.power ){
          this.filteredProducts = this.products.filter( p => (p.payload.doc.data().power === this.power) );
        }
        else if( this.categorySlug === 'all'){
          this.filteredProducts = this.products;
        }
        else if( this.categorySlug ){
          this.filteredProducts = this.products.filter( p=> (p.payload.doc.data().category === this.categorySlug) || (p.payload.doc.data().brand === this.categorySlug) );
        }
        else{
          this.filteredProducts = this.products;
        }
        this.loader = false;
        /* this.filteredProducts = (this.brand || this.power || this.categorySlug) ? 
        this.products.filter( p => (p.payload.doc.data().brand === this.brand) && (p.payload.doc.data().power === this.power) && (p.payload.doc.data().category === this.categorySlug) ) 
        : this.products; */
      });
    });



  }

  /* filterClicked(obj){
    this.route.queryParams.subscribe(params => {
      if( obj.brand == this.brand ){
        console.log('repeated');
        this.router.navigate([], {
          queryParams: {brand: undefined},
          queryParamsHandling: 'merge', // because you do not want to erase parameters set by other app's components
      });
      }else{
        console.log('not repeated');
      }
    });
  } */

  
  /* getProducts(){
    this.productService
    .getProducts()
    .subscribe(res => this.products = res);
  } */

  ngOnInit() {
    // this.getProducts();
    
    // let slug = this.route.snapshot.params['category'];
    let slug = this.categorySlug.replace(/-/g, ' ');
    this.collection = {
      category:slug
    }
    this.brands =[
      {'_id':'001','slug':'roshani_solar', 'label':'Roshani Solar'},
      {'_id':'002','slug':'luminous','label':'Luminous'}
    ];

    this.powers =[
      {'_id':'001','slug':'1-kw', 'label':'1 kw'},
      {'_id':'002','slug':'10-kw','label':'10 kw'}
    ];
  }

  filterStatus:boolean = false;

  openFilter(){
    this.filterStatus = !this.filterStatus;
  }

  activeProduct = {
    id:"865321546",
    image: "./assets/images/product-1.jpg",
    name:"Roshani solar panel 180 watt / 12 volt mono crystalline",
    warranty:"25 Years*",
    originalPrice:"12,500",
    category:'on-grid-system',
    offerPrice:"7,500",
    saved:"5,000",
    availability:'In Stock',
    percentOff:"40%",
    reviewsCount:21,
    images:[
      {'image':'./assets/images/product-1.jpg'},
      {'image':'./assets/images/product-2.jpg'},
      {'image':'./assets/images/product-3.jpg'},
      {'image':'./assets/images/product-4.jpg'}
    ],
    summary:"Roshani solar launches first time in India, Solar AC Module i.e. you can run your home appliances such as Fan, Television, Refrigerator, Air-cooler, Air Conditioner during the day directly from solar without Inverters, Batteries. The Solar AC module is designed to make every home solar powered in Metro city, big towns, Capital cities without hassles.",
    descriptions:[
      {'label':'Brand','value':'Roshani Solar'},
      {'label':'Panel Rating (Input)','value':'340 Watts / Mono Crystalline'},
      {'label':'Working Time','value':'During the day (9 am – 5 pm)'}
    ],
    packageComponents:[
      {'component':'340 watt solar ac module'},
      {'component':'Solar panel stand: made of galvanized iron'},
      {'component':'Connecting Cables'},
      {'component':'Standard installation – Do it yourself'}
    ],
    displays:[
      {'display':'Orange : Solar is generating AC power'},
      {'display':'Flashing Red : There is no grid power available.'},
      {'display':'Solid Red: There is no sun power available.'}
    ],
    technical:[
      {'label':'AC output voltage','value':'230 V, 1 phase'},
      {'label':'AC output power (Continuous)','value':'-280 watts'},
      {'label':'AC output current','value':'1.25 amps'},
      {'label':'Protection','value':'IP 67, Water proof and dust proof'},
      {'label':'Installation type','value':'Do it yourself'}
    ],
    questionsAnswers:[
      {'question':'I want to ask a question that if i will buy 180 watt poly panel and 180 watt mono panel and install them on a same place. If temperature ariives at 50 degree celcious. which panel give more power mono or poly. same question if same panel are in 25 degree temperature then which panel give more power. i lve in UP and i have luminous 160 watt poly panel and ai want to buy a solis mono panel from loom solar. please suggest.', 'answer':'solar panel efficiency is tested at standard 25 degree celcious. At 25 degree celcious, the efficiency of mono crystalline panel will be 3% higher than poly crystalline, but when temprage increases to 50 degree celcious, To check weather which solar panel will perform better in high tempratue, check solar panel technical data sheet, Typically, solar panels based on monocrystalline and polycrystalline solar cells will have a temperature coefficient in the –0.44% to -.50%. temperature coefficien means is that for each degree over 25˚C … the maximum power of the panel is reduced by 0.44%. i.e. Mono crystalline is always better.'},
      {'question':'This is sample question', 'answer':'This is sample answer'}
    ],
    reviews:[
      {
        'title':'Good Product Packing and Quality is seem good',
        'reviewBy':'Ajay Sharma',
        'postedOn':'8 Jan 2019',
        'description':'Quality of product is good but delivery time is much. Also it is difficult to find response from customer care. They require very much improvement. I find difficulty to connect wire in connection box provided at back side of panel as this is very small and customer care ask me to connect 2.5 sq mm wire. But I can not able to connect 1.5 sq mm wire due to less space and not able to tight the screw.'
      },
      {
        'title':'Good Product Packing and Quality is really niece ',
        'reviewBy':'Ajay Verma',
        'postedOn':'24 March 2019',
        'description':'Quality of product is good but delivery time is much. Also it is difficult to find response from customer care. They require very much improvement. I find difficulty to connect wire in connection box provided at back side of panel as this is very small and customer care ask me to connect 2.5 sq mm wire. But I can not able to connect 1.5 sq mm wire due to less space and not able to tight the screw.'
      }
    ],
    policy:'All products purchased have 30-days carry in warranty as standard. The carry in warranty period begins from the day of product delivery date. The warranty covers all of the items and conditions identified in original manufacturer warranty. Some of the items specifically are not covered by the warranty such as: loss and theft, Natural damage and customer abuse. No returns are accepted and Customer bears the cost for return of the product. Customer should check product immediately on receipt for all product functionality or missing items or for any kind of damage to the product. After the closure of return window policy; only manufacturing defects will be taken in to consideration under warranty terms. For correspondence you may write to sales@loomsolar.com'
  };

  open(content,id) {
    // console.log(id);
    let productId = id;
    this.modalService.open(content,{size:'lg',scrollable: true })
    .result.then((result) => {
      this.closeResult = `Closed with: ${result}`;
    }, (reason) => {
      this.closeResult = `Dismissed ${this.getDismissReason(reason)}`;
    });
  }

  openModal(productId){
    const modalRef = this.modalService.open(QuickLookComponent,{size:'lg',scrollable: true })
    modalRef.componentInstance.activeProductId = productId;
  }

  sortFilter(value){
    console.log('value',value);
    this.router.navigate(['/collections/'+this.categorySlug], { queryParams: { sort_by: value}, queryParamsHandling: 'merge' });
  }

  private getDismissReason(reason: any): string {
    if (reason === ModalDismissReasons.ESC) {
      return 'by pressing ESC';
    } else if (reason === ModalDismissReasons.BACKDROP_CLICK) {
      return 'by clicking on a backdrop';
    } else {
      return  `with: ${reason}`;
    }
  } 
}
